module.exports = __webpack_public_path__ + "img/img-2.370b44d2.jpg";